/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsArrowBoldRight: {
  name: 'arrow-bold-right';
  data: string;
} = {
  name: 'arrow-bold-right',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M12.553 5.106A1 1 0 0 1 13.6 5.2l8 6a1 1 0 0 1 0 1.6l-8 6A1 1 0 0 1 12 18v-2H4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h8V6a1 1 0 0 1 .553-.894ZM14 8v1a1 1 0 0 1-1 1H4v4h9a1 1 0 0 1 1 1v1l5.333-4L14 8Z" fill="currentColor"/></svg>`,
};
